import { SystemBars, SystemBarsStyle } from '@capacitor/core';

import { isNativePlatform } from '@/application/utils/envInfo';

export { SystemBarsStyle };

export const DEFAULT_SYSTEM_BARS_STYLE = SystemBarsStyle.Light;

let currentStyle: SystemBarsStyle | null = null;

export async function setSystemBarsStyle(style: SystemBarsStyle): Promise<void> {
  if (!isNativePlatform || style === currentStyle) return;

  currentStyle = style;
  await SystemBars.setStyle({ style });
}

export async function resetSystemBarsStyle(): Promise<void> {
  await setSystemBarsStyle(DEFAULT_SYSTEM_BARS_STYLE);
}
